// Записи клиента на этом устройстве: только токены своих записей, по студии.
// Это не приватный кэш кабинета: данные владельца в хранилище не пишутся.
const key = (slug: string) => `studio:${slug}:bookings`;

export interface SavedBooking {
  token: string;
  startsAt: string;
  serviceName: string;
  savedAt: string;
}

export function savedBookings(slug: string): SavedBooking[] {
  try {
    const raw = localStorage.getItem(key(slug));
    const list = raw ? (JSON.parse(raw) as SavedBooking[]) : [];
    return Array.isArray(list) ? list.filter((b) => typeof b.token === 'string') : [];
  } catch {
    return [];
  }
}

export function saveBooking(slug: string, b: SavedBooking): void {
  try {
    const list = savedBookings(slug).filter((x) => x.token !== b.token);
    list.unshift(b);
    localStorage.setItem(key(slug), JSON.stringify(list.slice(0, 20)));
  } catch {
    /* хранилище недоступно (приватный режим) — запись всё равно доступна по ссылке */
  }
}

export function forgetBooking(slug: string, token: string): void {
  try {
    localStorage.setItem(key(slug), JSON.stringify(savedBookings(slug).filter((x) => x.token !== token)));
  } catch {
    /* ignore */
  }
}

/** Черновик контактов, чтобы не вводить их повторно */
export interface ContactDraft {
  name: string;
  phone: string;
  car: string;
}

export function loadContact(): ContactDraft | null {
  try {
    const raw = localStorage.getItem('studio:contact');
    return raw ? (JSON.parse(raw) as ContactDraft) : null;
  } catch {
    return null;
  }
}

export function saveContact(c: ContactDraft): void {
  try {
    localStorage.setItem('studio:contact', JSON.stringify(c));
  } catch {
    /* ignore */
  }
}
